import React, { useEffect, useRef, useState } from "react";
import "./ChatBotPopUp.scss";
import chatNow from "../../assets/images/chat-now.svg";
import { generateRandomNumber } from "../../util/utils";
import {
  getChatbotQueAnsData,
  getIssueListByProductId,
  submitUnknownQuestionUrl,
} from "../Services/Constant";
import { toast } from "react-toastify";
import { HTTPS } from "../../services/HTTPS";
import okGenieLogo from "../../assets/images/okGenie.svg";
import crossIcon from "../../assets/images/cross-icon.svg";
import genieMainLogo from "../../assets/images/genieMainLogo.svg";
import send_button from "../../assets/images/send_button.svg";
import copyIcon from "../../assets/images/copyIcon.svg";
import likeBtnDefault from "../../assets/images/like-default.svg";
import likeThanku from "../../assets/images/like-thnku.svg";
import dislike from "../../assets/images/dislike.svg";
import genieLogogif from "../../assets/images/genieGifLogo.gif";
import { useTranslation } from "react-i18next";


function ChatBotPopUp({ open, close }) {
  const toastId = useRef(null);
  const [chatbotSuggestions, setChatbotSuggestions] = useState([]);
  const [stepName, setStepName] = useState("chatBotSplash");
  const [chatHistory, setChatHistory] = React.useState([]);
  const [currentQuestions, setCurrentQuestions] = React.useState([]);
  const [activeQA, setActiveQA] = React.useState(null);
  const [showQuestions, setShowQuestions] = React.useState(true);
  const chatContainerRef = useRef(null);
  const [userInput, setUserInput] = useState("");
  const [currentCategory, setCurrentCategory] = useState(null);
  const [liked, setLiked] = useState(false);

  const handleLikeClick = () => {
    setLiked(true);
  };
  const { t } = useTranslation();

  useEffect(() => {
    fetchChatBotQueData();
  }, []);

  const fetchChatBotQueData = async () => {
    // setLoading(true);
    const mobile = sessionStorage.getItem("mobile");
    const info = {
      HEADER: {
        mobile: mobile,
        sellerCode: sessionStorage.getItem("sellerCode"),
        UDID: sessionStorage.getItem("ipAddress"),
        REQUEST_ID: generateRandomNumber(),
      },
      DATA: {
        // productId: productIdFromQuery,
      },
    };

    await HTTPS(getChatbotQueAnsData, info)
      .then((formResponse) => {
        // setLoading(false);
        if (formResponse.RESP_CODE === 300) {
          setChatbotSuggestions(formResponse.DATA);
          // setStepName("chatBotCategory");
          setTimeout(() => {
            setStepName("chatBotCategory");
          }, 3000);


          console.log("queAnsdata", formResponse);
        } else {
          console.log("Issue List by ProductId", formResponse);

          //   setLoading(false);
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.error(formResponse.RESP_MSG);
          }
        }
      })
      .catch((error) => {
        // setLoading(false);
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error(error);
        }
      });
  };
  const submitUnknownQuestion = async (question) => {
    // setLoading(true);
    const mobile = sessionStorage.getItem("mobile");
    const info = {
      HEADER: {
        mobile: mobile,
        sellerCode: sessionStorage.getItem("sellerCode"),
        UDID: sessionStorage.getItem("ipAddress"),
        REQUEST_ID: generateRandomNumber(),
      },
      DATA: {
        question: question
        // productId: productIdFromQuery,
      },
    };

    await HTTPS(submitUnknownQuestionUrl, info)
      .then((formResponse) => {
        // setLoading(false);
        if (formResponse.RESP_CODE === 300) {

          if (activeQA) {
          setChatHistory((prev) => [...prev, activeQA]);
        }
        
          const newQA = {
            question: question,
            answer: formResponse.RESP_MSG || "Thank you for your query.",
          };
          setActiveQA(newQA);
          setShowQuestions(false);

          console.log("Response saved question:", formResponse);

         
        } else {
         
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.error(formResponse.RESP_MSG);
          }
        }
      })
      .catch((error) => {
        // setLoading(false);
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error(error);
        }
      });
  };
  const handleChatBotCategoryClick = (category) => {
    setCurrentCategory(category)
    setChatHistory((prev) => {
      // If  active QA, save  history before chnng categroy
      const updatedHistory = activeQA ? [...prev, activeQA] : [...prev];
      return updatedHistory;
    });

    const categoryData = chatbotSuggestions.find(
      (cat) => cat.category === category
    );

  
    if (categoryData?.questions) {
      const questionsWithCategory = categoryData.questions.map((q) => ({
        ...q,
        category: categoryData.category,
      }));
      setCurrentQuestions(questionsWithCategory);
      setShowQuestions(true);
      setActiveQA(null);
    }


    if (stepName !== "chatBotQueAns") setStepName("chatBotQueAns");
  };

  const handleQuestionClick = (item) => {
    setChatHistory((prev) => {
      // Add previous active QA if exists before switchh
      const updated = activeQA ? [...prev, activeQA] : [...prev];
      return updated;
    });

    setActiveQA(item);
    setShowQuestions(false);
    setCurrentCategory(item.category);
  };


  useEffect(() => {
    const container = chatContainerRef.current;
    if (!container) return;

    const shouldScroll =
      container.scrollHeight > container.clientHeight;

    if (shouldScroll) {
      container.scrollTop = container.scrollHeight;
    }
  }, [activeQA, showQuestions,currentCategory]);
  const handleSendClick = () => {
    const trimmedInput = userInput.trim();
    const normalizedInput = trimmedInput.toLowerCase().normalize().trim();

    const allQuestions = chatbotSuggestions.flatMap(cat =>
      (cat.questions || []).map(q => ({
        ...q,
        category: cat.category,
        normalizedQuestion: q.question.toLowerCase().normalize().trim(),
      }))
    );

    const matchedQuestions = allQuestions.filter(q =>
      q.normalizedQuestion.includes(normalizedInput)
    );

    console.log("Search input:", trimmedInput);
    console.log("Matched questions:", matchedQuestions.map(q => q.question));

    if (matchedQuestions.length > 0) {
      setChatHistory(prev => (activeQA ? [...prev, activeQA] : [...prev]));
      setCurrentQuestions(matchedQuestions);
      setShowQuestions(true);
      setActiveQA(null);
    } else {
      submitUnknownQuestion(trimmedInput);
    }

    setUserInput("");
  };


  const handleCopy = () => {
    if (activeQA && activeQA.answer) {
      navigator.clipboard.writeText(activeQA.answer)
        .then(() => {
          // toast.success("Copied")
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.success("Copied");
          }
        })
        .catch(() => {
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.error("Please try after some time");
          }
        });
    }
  };

  const handleDislikeClick = () => {
    if (currentCategory) {
      const categoryData = chatbotSuggestions.find(cat => cat.category === currentCategory);
      const questionsWithCategory = (categoryData?.questions || []).map(q => ({
        ...q,
        category: categoryData.category,
      }));
      setCurrentQuestions(questionsWithCategory);
    } else {
      setCurrentQuestions([]);
    }
    setShowQuestions(true);
  };
  useEffect(() => {
    if (setShowQuestions) {
      setLiked(false)
    }
  }, [activeQA])


  return (
    <div className="chat-bot-pop-up">
      {stepName === "chatBotSplash" && (
        <div className="chat-bot-splash-screen">
          <img src={genieLogogif} alt="Ok Genie" className="genie-logo" />
        </div>
      )}
      {stepName === "chatBotCategory" && (
        <div className="chat-bot-category">
          <img
            src={crossIcon}
            alt="Cross"
            className="cross-icon"
            onClick={() => close()}
          />     
          <div className="chat-bot-title-category">
            <h5 className="main-title">
              {t("chatbot.heyThere")} <span>{t("chatbot.okGenie")}</span>
            </h5>
            <h6 className="secondary-title"> {t("chatbot.whatCanIHelpYouWith")}</h6>
            <div className="categories">
              {chatbotSuggestions.map((category, index) => (
                <p
                  key={category + index}
                  className="category-name"
                  onClick={() => handleChatBotCategoryClick(category.category)}
                >
                  {category.category}
                </p>
              ))}
            </div>
          </div>
          {/* <img src={chatNow} className="chat-now" /> */}
        </div>
      )}
      {stepName === "chatBotQueAns" && (
        <div className="chat-bot-que-ans">
          <div className="main-chat-header">
            <div className="logo-name-container">
              <img src={genieMainLogo} alt="OK GENIE" className="genie-logo" />
              <div className="name-status">
                <p className="genie-name">{t("chatbot.okGenie")}</p>
                <p className="genie-status">{t("chatbot.online")}</p>
              </div>
            </div>
            <img
              src={crossIcon}
              alt="Cross"
              className="cross-icon"
              onClick={() => close()}
            />
          </div>
          {/* working code */}
          <div className="chat-slider-input-container">
            <div className="chat-messages-container" ref={chatContainerRef}>
              {chatHistory.map((qa, idx) => (
                <React.Fragment key={idx}>
                  <div className="chat-bubble question">{qa.question}</div>
                  <div className="chat-bubble answer">{qa.answer}</div>
                </React.Fragment>
              ))}

              {/* Render active (latest) Q&A */}
              {activeQA && (
                <>
                  <div className="chat-bubble question">{activeQA.question}</div>
                  <div className="chat-bubble answer">
                    {activeQA.answer}

                    {!showQuestions && (
                      <div className="feedback-icons-on-border">
                        <img
                          src={copyIcon}
                          alt="Copy"
                          className="icon-btn"
                          title="Copy"
                          onClick={handleCopy}
                        />
                        <img
                          src={liked ? likeThanku : likeBtnDefault}
                          alt="like"
                          className={`icon-btn ${liked ? "liked" : ""}`}
                          title="Copy"
                          onClick={handleLikeClick}
                        />
                        <img
                          src={dislike}
                          alt="Dislike"
                          className="icon-btn"
                          title="Dislike"
                          onClick={() => handleDislikeClick()}
                        />
                      </div>
                    )}
                  </div>
                </>
              )}

              {showQuestions &&
                currentQuestions.map((q, idx) => (
                  <div
                    key={idx}
                    className={`chat-bubble question ${showQuestions ? "hoverable" : ""}`}
                    onClick={() => handleQuestionClick(q)}
                  >
                    {q.question}
                  </div>
                ))}
            </div>
            <div className="category-slider">
              {chatbotSuggestions.map((category, index) => (
                <p
                  key={category + index}
                  className="chat-category"
                  onClick={() => handleChatBotCategoryClick(category.category)}
                >
                  {category.category}
                </p>
              ))}
            </div>

            <div className="bottom-chat-container">
              <div className="input-container">
                <input
                  placeholder="Message.."
                  className="input-field"
                  value={userInput}
                  maxLength={500}
                  onChange={(e) => setUserInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && userInput.trim().length >= 2) {
                      e.preventDefault();
                      handleSendClick();
                    }
                  }}
                />
                <img
                  src={send_button}
                  alt="send"
                  className={`sent-msg-button ${userInput.trim().length < 2 ? "disabled" : ""}`}
                  onClick={userInput.trim().length >= 2 ? handleSendClick : undefined}
                />


              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ChatBotPopUp;
